import { FilterMetadata, SortMetadata } from '../../ng-data-table';
import { Observable } from 'rxjs';

export interface DataSource {
  clearAllFilters();
  getItems(requestMeta: RequestMetadata): Promise<PagedResult>;
  getItemsByID(requestMeta: RequestMetadata): Promise<PagedResult>;
  getItem(row: any): Promise<any>;
  post(row: any, methodName: string): Promise<any>;
  put(row: any, methodName: string): Promise<any>;
  delete(row: any, methodName: string): Promise<any>;
  getOptions?(url: string, parentId: any): Promise<any>;
}

export interface HeaderDataSource {
  getTotalRecords(rsltType: any): Observable<number>;
  getItems(dates: any, dateOperator: any, rsltType: any): Observable<any>;
}

export class RequestMetadata {
  pageMeta: PageMetadata;
  sortMeta: SortMetadata[];
  filters: FilterMetadata;
  globalFilterValue?: string;
  rsltType?: string;
  rsltTypeActual?: string;
  ResultOrFileType?: number;//Export to file or just display
  id?: number;
  respColumnsList?: string[];//Used while exporting to file using global cols filtering
  groupRowsBy?: boolean;

}

export class PagedResult {
  items: any[];
  itemsRest: any[];
  _meta: PageMetadata;
}

export class PageMetadata {
  currentPage: number;
  perPage: number;
  perPageOrCurrPageChanged: boolean;
  totalCount?: number;
  pageCount?: number;
  maxRowCount?: number;
  //clearSortOrder?: boolean;
}
